import React from 'react';
import { BrandOverviewPage } from '~/features/brand-overview/BrandOverviewPage';
import { Modules, BrandsListPageProps as BrandsListPageType } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';

type BrandsListPageProps = BrandsListPageType;

export const BrandsListPage = (props: BrandsListPageProps) => {
    return (
        <>
            <DynamicBlockList elements={props.pageElements as Modules[]} />
            <BrandOverviewPage brands={props?.data?.brands} />
            <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
        </>
    );
};
